import React from 'react';
import PerfectScrollbar from "react-perfect-scrollbar";
import {X} from "react-feather";
import {Dialog, Box, CircularProgress, IconButton} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import StateTabs from "src/components/StateTabs";
import FormToolbox from "../AdminExperience/Workflows/ManagePerspective/WidgetSelectors/FormToolbox";
import usePerspective from "../AdminExperience/Workflows/ManagePerspective/common/usePerspective";
import Inspector from "../AdminExperience/Workflows/ManagePerspective/Drawers/Inspector";
import FormEditor from "../AdminExperience/Workflows/ManagePerspective/Editors/FormEditor";
import useGetRequest from "../../hooks/useGetRequest";


const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    borderRadius: theme.spacing(3)
  },
  left: {
    flex: '1 1',
    display: 'flex',
    position: 'relative',
    backgroundColor: (theme.palette.background as any).dark,
    alignItems: 'center',
    justifyContent: 'center',
  },
  right: {
    flex: '1 1',
    maxWidth: 400,
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    flex: '1 1',
    display: 'flex',
    overflow: 'hidden',
  },
  exit: {
    position: "absolute",
    zIndex: 2000,
  },
  children: {
    height: '100%',
  }
}));

interface FormBuilderModalContentProps {
  onClose: () => void,
  workflowId: string,
  perspectiveId: string,
}

const tabs = [
  {
    route: 'toolbox',
    label: 'Toolbox',
    component: FormToolbox,
  },
  {
    route: 'inspector',
    label: 'Inspector',
    component: Inspector,
  },
];

const FormBuilderModalContent = ({
  onClose,
  workflowId,
  perspectiveId,
}: FormBuilderModalContentProps) => {
  const classes = useStyles();
  const [currentTabRoute, setCurrentTabRoute] = React.useState(tabs[0].route);

  const {
    result: table,
    isLoading: tableLoading,
    httpRequest: refreshFields
  } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/table/`,
    initialResult: { fields: [] },
  });

  const {
    onDragStart,
    onDragStop,
    onDrop,
    saveWidget,
    onResizeStop,
    deleteWidget,
    selectWidget,
    isDragging,
    setIsDragging,
    widgets,
    perspective,
    selectedWidget,
    getPerspective: refreshPerspective,
    isLoading,
  } = usePerspective({
    workflowId,
    perspectiveId,
  });


  React.useEffect(() => {
    if (selectedWidget) setCurrentTabRoute('inspector');
  }, [selectedWidget])

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      maxWidth="xl"
      onClose={onClose}
      open
      keepMounted
      fullWidth
    >
      <Box className={classes.container}>
        <Box className={classes.exit}>
          <IconButton onClick={() => onClose()}>
              <X />
          </IconButton>
        </Box>
        <Box className={classes.left}>
          {
            !perspective && isLoading ? (
              <CircularProgress />
            ) : (
              <FormEditor
                widgets={widgets}
                workflowId={workflowId}
                fields={table.fields}
                refreshPerspective={refreshPerspective}
                isDragging={isDragging}
                onDragStart={onDragStart}
                onDragStop={onDragStop}
                onDrop={onDrop}
                onResizeStop={onResizeStop}
                selectWidget={selectWidget}
                maxWidth={perspective && perspective.width}
                title={perspective && perspective.name || ''}
              />
            )
          }
        </Box>
        <Box className={classes.right}>
          <PerfectScrollbar options={{ suppressScrollX: true }}>
            <Box pl={2} pr={2} pb={2} className={classes.children}>
              {
                  <StateTabs
                    tabs={tabs}
                    currentTabRoute={currentTabRoute}
                    setCurrentTabRoute={setCurrentTabRoute}
                    componentProps={{
                      // toolbox props
                      widgets,
                      fields: table.fields,
                      refreshFields,
                      refreshPerspective,

                      // inspector props
                      selectedWidget,
                      deleteWidget,
                      saveWidget,

                      // shared
                      perspectiveId,
                      workflowId,
                    }}
                  />

              }
            </Box>
          </PerfectScrollbar>
        </Box>
      </Box>
    </Dialog>
  );
};

export default FormBuilderModalContent;
